<template>
  <svg
    id="milestone-smashing"
    :x="svgCoords.x"
    :y="svgCoords.y"
    width="300"
    height="400"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 254.6 320.8"
    aria-labelledby="smashingmigratestojamstack"
    role="presentation"
  >
    <title id="smashingmigratestojamstack">smashing migrates to jamstack</title>
    <g id="Blocke_2" data-name="Blocke 2">
      <g id="Shadow">
        <polygon class="cls-1" points="217.7 226.7 237.2 215.5 236.5 215 217 226.2 217.7 226.7" />
        <path
          class="cls-1"
          d="M212.9,223.9l19.4-11.2-.9-.3-18.9,10.9C212.6,223.6,212.6,223.8,212.9,223.9Z"
          transform="translate(-1 -0.7)"
        />
        <polygon
          class="cls-1"
          points="213.8 224.4 233.2 213.2 232.6 212.7 213.1 223.9 213.8 224.4"
        />
        <polygon
          class="cls-1"
          points="215.8 225.5 235.2 214.3 234.5 213.9 215.1 225.1 215.8 225.5"
        />
        <polygon
          class="cls-1"
          points="227.1 232.1 227.4 232.3 246.8 221.1 246.1 220.6 232.7 228.4 232.6 228.2 223.8 233.3 194 250.5 194.7 250.9 225.1 233.3 227.1 232.1"
        />
        <path
          class="cls-1"
          d="M230.4,234.1l19-10.9c0-.3-.2-.4-.5-.6l-13.2,7.6h-.1l-38.5,22.2v.2l.6.3L230.1,234Z"
          transform="translate(-1 -0.7)"
        />
        <polygon class="cls-1" points="236.5 230.5 198 252.8 198.7 253.2 237.2 230.8 236.5 230.5" />
        <polygon
          class="cls-1"
          points="238.5 231.7 200 253.8 200.2 254.1 200.6 254.2 239.2 232 238.5 231.7"
        />
        <polygon
          class="cls-1"
          points="240.4 232.7 201.9 254.9 202.6 255.4 241.1 233.1 240.4 232.7"
        />
        <polygon
          class="cls-1"
          points="242.4 233.8 203.8 256.1 203.9 256.1 204.5 256.5 243.1 234.3 242.4 233.8"
        />
        <polygon class="cls-1" points="244.2 235 205.8 257.2 206.5 257.7 244.9 235.4 244.2 235" />
        <polygon
          class="cls-1"
          points="246.2 236.1 207.8 258.4 207.9 258.5 208.5 258.8 247 236.6 246.2 236.1"
        />
        <polygon class="cls-1" points="248.2 237.3 209.6 259.5 210.4 260 249 237.7 248.2 237.3" />
        <polygon
          class="cls-1"
          points="250.3 238.4 211.8 260.7 211.8 260.8 212.4 261.1 250.8 238.9 250.3 238.4"
        />
        <polygon class="cls-1" points="252.1 239.6 213.7 261.8 214.2 262.3 252.8 240 252.1 239.6" />
        <path
          class="cls-1"
          d="M254.8,241.6l-38.2,21.9.2.2.6.3,37.8-21.8C255.1,242,255,241.7,254.8,241.6Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-1"
          d="M219.2,264.3h1.5l34.5-20a1.7,1.7,0,0,0,.3-1Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-1"
          d="M220.7,228.5,240,217.3l-.7-.4-14.2,8.2h-.4l-35.5,20.5v.9l31.2-18.1Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-1"
          d="M222.7,229.7,242,218.5l-.7-.5L228,225.8c-.2,0-.2-.2-.3-.2l-38.2,22c.2.1.3.4.4.6l32.5-18.7Z"
          transform="translate(-1 -0.7)"
        />
        <polygon
          class="cls-1"
          points="223.6 230 242.9 218.8 242.2 218.3 228.9 226.1 228.7 225.9 190.1 248.2 190.8 248.6 223.3 229.8 223.6 230"
        />
        <polygon
          class="cls-1"
          points="225.4 231.1 244.8 219.9 244.2 219.5 230.9 227.2 230.6 227.1 192.1 249.3 192.8 249.8 225.3 231 225.4 231.1"
        />
      </g>
      <g class="sbox" id="Box_3" data-name="Box 3">
        <path
          class="cls-2"
          d="M189.5,236.7s0,.1.2.1l2.2,1.3V234l-2.5-1.4Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-2"
          d="M216.5,248.3l-23.4-13.6v4.1l24.1,14.3h1.3v-4.6h-.6A2.8,2.8,0,0,1,216.5,248.3Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-3"
          d="M218.7,215a3,3,0,0,0-1.8.2l-27.2,15.6-.3.3,27.7,16.1a2.7,2.7,0,0,0,1.7-.2l27.3-15.6c.1-.2.3-.2.3-.3h-.2Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-1"
          d="M247.5,231.2a1.5,1.5,0,0,0-.7-1.1L219.2,214a2.8,2.8,0,0,0-2.8.2l-27.3,15.6a1.3,1.3,0,0,0-.8,1.1.8.8,0,0,0-.2.5v5.4a1.5,1.5,0,0,0,.7,1.2l27.6,16.1,1.2.2a2.5,2.5,0,0,0,1.3-.3h.2l27.4-15.5c.6-.5.9-.8.9-1.3v-5.5h0C247.4,231.6,247.5,231.4,247.5,231.2Zm-55.6,6.9-2.2-1.3c-.2,0-.2-.1-.2-.1v-4.1L192,234Zm26.5,15h-1.3L193,238.8v-4.1l23.4,13.6a2.8,2.8,0,0,0,1.3.3h.6Zm24-13.1h-1.1v-4.9h1Zm3.7-8.6L218.8,247a2.7,2.7,0,0,1-1.7.2l-27.7-16.1.3-.3,27.2-15.6a3,3,0,0,1,1.8-.2l27.5,16.1h.2C246.4,231.2,246.2,231.2,246.1,231.4Z"
          transform="translate(-1 -0.7)"
        />
        <rect
          class="cls-2"
          x="239.4"
          y="237.1"
          width="4.9"
          height="1"
          transform="matrix(0.02, -1, 1, 0.02, -0.5, 474.96)"
        />
      </g>
      <g class="sbox" id="Box_2" data-name="Box 2">
        <path
          class="cls-3"
          d="M202.6,242.7l-3.8,2.6,3.3,2a2,2,0,0,1,.8.8l3.8-2.4a1.4,1.4,0,0,0-.2-.7Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-1"
          d="M207,243.9l-3.8-2.3a1.1,1.1,0,0,0-1.1,0l-4.7,3c-.2.2-.4.4-.4.6a1.1,1.1,0,0,0-.3.8v3.8a1.9,1.9,0,0,0,1,1.7l3.9,2.3h1l.3-.2,4.7-2.8v-.2a1.6,1.6,0,0,0,.3-.8v-4.2A1.9,1.9,0,0,0,207,243.9Zm-3.8,7.6-.5-.9,4.2-2.5.5.9Zm-.3-3.4a2,2,0,0,0-.8-.8l-3.3-2,3.8-2.6,3.9,2.3a1.4,1.4,0,0,1,.2.7Zm-5.1-1.9,3.6,2.1a1.1,1.1,0,0,1,.3.7v3.5h0l-3.6-2.1a2.1,2.1,0,0,1-.3-.7Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-2"
          d="M198.1,250.5l3.6,2.1h0V249a1.1,1.1,0,0,0-.3-.7l-3.6-2.1v3.6A2.1,2.1,0,0,0,198.1,250.5Z"
          transform="translate(-1 -0.7)"
        />
        <rect
          class="cls-2"
          x="202.6"
          y="249.3"
          width="4.9"
          height="1"
          transform="translate(-100.4 140.7) rotate(-31)"
        />
      </g>
      <g class="sbox" id="Box_1" data-name="Box 1">
        <path
          class="cls-2"
          d="M222.8,223.7h-.6l-1.3-.3-17.3-10.1v4.2s0,.2.1.2l17.7,10.4a1.7,1.7,0,0,0,1.4,0Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-3"
          d="M203.7,211.7c0,.3,0,.3-.1.3h.1l17.7,10.2a2.1,2.1,0,0,0,1.7-.1l17.5-10,.3-.3h-.1L223,201.5a2.9,2.9,0,0,0-1.8.2Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-1"
          d="M242.2,212a1.5,1.5,0,0,0-.7-1.1l-17.8-10.4a3,3,0,0,0-2.9.2l-17.5,10a1.4,1.4,0,0,0-.8,1.1c-.1.2-.2.3-.2.5v5.5a1.5,1.5,0,0,0,.7,1.1l17.8,10.3a2.8,2.8,0,0,0,1.3.3,1.9,1.9,0,0,0,1.3-.3h.1l17.8-9.9c.6-.4.9-.7.9-1.3v-5.4a.5.5,0,0,1,0-.6Zm-20.8,16.2-17.7-10.4c-.1,0-.1-.2-.1-.2v-4.2l17.3,10.1,1.3.3h.6v4.5A1.7,1.7,0,0,1,221.4,228.2Zm1.6-26.7,17.8,10.4h.1l-.3.3-17.5,10a2.1,2.1,0,0,1-1.7.1l-17.7-10.2h-.1c.1,0,.1,0,.1-.3l17.5-10A2.9,2.9,0,0,1,223,201.5Zm13.1,19.2v-4.8h1v4.8Z"
          transform="translate(-1 -0.7)"
        />
        <rect
          class="cls-2"
          x="234.2"
          y="217.8"
          width="4.9"
          height="1"
          transform="translate(13.6 450.7) rotate(-89.1)"
        />
      </g>
      <g id="Gear">
        <path
          class="cls-2"
          d="M222,217.3l-3.6-.6.4-1-1-.4a2.8,2.8,0,0,1-.9-.7l-1.5.3-1.2-2.5,1.7-.2a3.2,3.2,0,0,1,.6-1.5l-1.3-.7,2.9-1.7,1.1.7a9.2,9.2,0,0,1,2.9-.4l.4-.9,3.6.6-.4,1,1,.4.9.7,1.5-.3,1.2,2.5-1.7.3a2.8,2.8,0,0,1-.6,1.4l1.3.7-2.9,1.7-1.1-.7a9.3,9.3,0,0,1-2.9.5Zm-2.3-1.3,1.7.3.4-.8h.3a11.9,11.9,0,0,0,3.2-.5h.1l1,.6,1-.6-1-.5.4-.5a2.1,2.1,0,0,0,.8-1.6V212h1.2l-.2-.7-1.5.2H227a2.8,2.8,0,0,0-.9-.7,3.2,3.2,0,0,0-1.3-.6h-.6l.5-.9-1.7-.3-.5.9h-.3a10.6,10.6,0,0,0-3.1.4h-.2l-1-.5-1,.5,1,.6-.4.5a2.3,2.3,0,0,0-.7,1.5v.5h-1.3l.3.7,1.4-.3.2.2a1.8,1.8,0,0,0,.8.7l1.3.6h.6Zm2.5-1.5a3.6,3.6,0,0,1-2.4-.9,1.4,1.4,0,0,1-.4-1,1.3,1.3,0,0,1,.4-1,3.8,3.8,0,0,1,4.9,0,1.4,1.4,0,0,1,.4,1,1.3,1.3,0,0,1-.4,1A3.7,3.7,0,0,1,222.2,214.5Zm0-2.9c-.7,0-1.4.1-1.7.6s-.1.2-.1.4v.4a3.3,3.3,0,0,0,3.6,0,.6.6,0,0,0,.1-.4c0-.2-.1-.3-.1-.4A2.3,2.3,0,0,0,222.2,211.6Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-1"
          d="M226.5,208.9a3,3,0,0,0-1.4-.6l.4-.9L223,207l-.5.9a9.1,9.1,0,0,0-3.3.5l-1.1-.5-2,1.1,1.1.6a2.4,2.4,0,0,0-.8,1.8l-1.5.3.7,1.6,1.6-.3,1,.9,1.5.6-.5.8,2.6.4.4-.8a8.8,8.8,0,0,0,3.3-.6l1.2.6,2-1.2-1.1-.5a3.1,3.1,0,0,0,.8-1.9l1.4-.3-.7-1.6-1.5.3A3.1,3.1,0,0,0,226.5,208.9Zm-2.1,3.1a3.6,3.6,0,0,1-4.2,0,1,1,0,0,1,0-1.4,3.6,3.6,0,0,1,4.2,0A1,1,0,0,1,224.4,212Z"
          transform="translate(-1 -0.7)"
        />
      </g>
    </g>
    <path
      ref="connecting-smashing"
      class="cls-10"
      d="M44,250.9l32.2-19.2s4.4-6.3,13.1,0,24.2,15.1,24.2,15.1,4.8,3.3,10.5-1,46.5-26.1,46.5-26.1,6.2-4.5,1.1-7.6-44.3-22.6-44.3-22.6-5.3-1.4-5.1-6.8-.6-48.9-.6-48.9-1.8-9.2,4.9-8.3,17.1,5.9,17.1,5.9,6.7,1.2,7.1-4.9-.5-60.8-.5-60.8"
      transform="translate(0 0)"
    />
    <g id="LOGO">
      <path
        d="M193.1,178l-1.8-1.9,2.2-1.3v-.7c-.4-1.5-1.3-3-3.3-6.4l-9.2-16-7.5-.7,5.2-3.1L170.2,133l-3.5,2,1-6.4-7,4,7-4-9.1-15.8-9.8,5.8,7.7-9.3-3-5.3c-1.9-3.2-2.9-4.9-4-5.9a7.5,7.5,0,0,0-1.4-1.2l-1.4-.5c-1.1-.3-2,.3-4,1.4l-16,9.3h0l16-9.3-13.9,7.9-2.1,1.3h-.1l-12.8,7.5h0l12.8-7.5-10.7,6.2-2.1,1.2h0l-13.5,7.9-10.1,5.8,14.8-8.7.8-.4L86.1,130.3h0c-1.9,1.1-2.9,1.6-3.2,2.7a3.7,3.7,0,0,0-.2,1.2h0l3.5,2.8-2.5,1.5,1.4,2.5.9,1.7,6.3,10.7,7.5.7-5.3,3.1h-.1l4.9,8.5h0l17.4-10h1.8l-11.2,6.6h-.2l-5.6,6.7,21.3,37c2,3.4,2.9,5,4,6.1a6.7,6.7,0,0,0,1.4,1.1,4.2,4.2,0,0,0,1.4.6h.5a6,6,0,0,0,2.7-1.1h0l2.1-1.2h0l2-1.1h0l3.5-2.1h.1l17.1-9.8h0l2.4-1.4h0l10.5-6,1.8-1.1-1,.6,19.6-11.5a6.5,6.5,0,0,0,2.3-1.7h-.1Z"
        transform="translate(-1 -0.7)"
      />
      <polygon class="cls-2" points="95.2 157.7 98.5 163.4 102.6 158.4 102.6 158.3 95.2 157.7" />
      <polygon class="cls-2" points="99.4 152.6 86 141.7 91.9 152 99.4 152.6" />
      <path
        class="cls-2"
        d="M107.2,163.9l-4.7,5.7,21,36.5c1.9,3.1,2.8,4.8,3.9,5.7l1.3,1a2.8,2.8,0,0,0,1.2.4h.3a2.3,2.3,0,0,0,1.4-.4l-20.9-47.2a6,6,0,0,1-2.1-.8Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-2"
        d="M83.6,133.8l20.3,16.7h.1c-3.5-7.7-6.9-15.6-10.3-23.3L86.5,131c-1.9,1.1-2.6,1.6-2.8,2.2S83.6,133.6,83.6,133.8Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-2"
        d="M135.9,210.4c.9-4.9,3.2-19.8,3.6-22.3a10.2,10.2,0,0,1-2.4-4.6l-21.8-17.9,20,45.1Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-2"
        d="M145.4,190.2l-1.1.5-2.6,16.4,14.3-8.2Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-2"
        d="M108.5,149.8l1.1.5.9.7,10.2-12.2a10,10,0,0,1-1.2-5.6c-.8-1-2.9-3.2-5.3-5.7l-7.4-8-9.3,5.3Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-2"
        d="M138.2,178.7a3,3,0,0,1,2-.6h.9l2.5-15.3-.3-.3-27.6-2.5Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-2"
        d="M141.6,157h0l-12.5-13.3a2.6,2.6,0,0,1-1.8.6,4.5,4.5,0,0,1-2.6-.9l-.3-.2-9.5,11.5Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-2"
        d="M160.1,196.4l9.9-5.6a10.8,10.8,0,0,0,2.1-1.4l-21.9-23.5a2.4,2.4,0,0,1-1.3.4h-.8l-2.4,15.5a13.6,13.6,0,0,1,1.5,4.1Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-2"
        d="M170.8,181.8c-.3-.7-.7-1.3-1.2-2.2l-8.9-15.5-7-.7Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-2"
        d="M149.6,156.2a4.9,4.9,0,0,1,1,1.5l6.8.6L151,147.2Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-2"
        d="M130.2,136.3a10.9,10.9,0,0,1,.8,2.8l13.5,14.5h.5l2-13.3L138.8,126Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-2"
        d="M110.7,117.4l.2.2,11.4,12.2h.7a5.9,5.9,0,0,1,2.7.8l1.1.8,8.9-10.7-2.7-4.7c-1.7-3.1-2.8-4.9-3.8-5.8a3.8,3.8,0,0,0-1.3-.9l-1.1-.5h-.3a7.5,7.5,0,0,0-3,1.3Z"
        transform="translate(-1 -0.7)"
      />
    </g>
    <g id="Wordpress_Logo" data-name="Wordpress Logo">
      <polygon class="cls-4" points="20.4 222 21.2 221.5 21.2 221.5 20.4 222 20.4 222" />
      <path
        class="cls-4"
        d="M49.9,265.3a15.1,15.1,0,0,0,.9-1.8l-2.9,1.7Z"
        transform="translate(-1 -0.7)"
      />
      <path class="cls-4" d="M18.5,207.7H16.4l-.9,1.8Z" transform="translate(-1 -0.7)" />
      <path
        class="cls-4"
        d="M26.9,238.1l-3.3-12.5,2.1-1.3h0l-2.1,1.3c-.2-.4-.3-.8-.8-1l1.7-1h0l-1.7,1-1.1-.6h0l1,.6a1.7,1.7,0,0,1,.9,1l3.3,12.5-.8,2.2h0l.8-2.2,5.1-3h0Z"
        transform="translate(-1 -0.7)"
      />
      <path class="cls-4" d="M47.5,271.4l-.3.3Z" transform="translate(-1 -0.7)" />
      <path
        class="cls-4"
        d="M46.8,265a18.5,18.5,0,0,0,3.5-9.9h-.1a17.7,17.7,0,0,1-3.5,9.8Z"
        transform="translate(-1 -0.7)"
      />
      <polygon class="cls-4" points="42.7 251.6 42.8 251.7 44 250.9 44 250.9 42.7 251.6" />
      <path class="cls-4" d="M39,230.8v0Z" transform="translate(-1 -0.7)" />
      <path
        class="cls-4"
        d="M39,232.5c.5,4.4,3.9,8.5,3.9,14.7C42.9,241,39.5,236.9,39,232.5Z"
        transform="translate(-1 -0.7)"
      />
      <path class="cls-4" d="M39.7,229.1h0Z" transform="translate(-1 -0.7)" />
      <path
        class="cls-4"
        d="M27.5,268.5h0l2.1-1.3h0l-2.1,1.3c-13.8-8-25-27.3-24.9-43.2h0c-.1,15.9,11.1,35.3,24.9,43.2Z"
        transform="translate(-1 -0.7)"
      />
      <path class="cls-4" d="M48.1,271h0Z" transform="translate(-1 -0.7)" />
      <path class="cls-4" d="M20.9,206.3l-3.2-.7h0l3.2.6Z" transform="translate(-1 -0.7)" />
      <path
        d="M27.5,268.5l2.1-1.3-2.1-1.1a44.9,44.9,0,0,1-6.7-5l7.1-19.2L35.1,269a22,22,0,0,1-5.5-1.8l-2.1,1.3h0c9.9,5.7,18.4,4,22.4-3.2h-2l2.9-1.7a23.8,23.8,0,0,0,1.7-9.3c0-15.9-11.1-35.2-24.9-43.2a24.6,24.6,0,0,0-9.1-3.3l-3,1.7.9-1.8c-8.2,0-13.8,6.5-13.8,17.7C2.5,241.2,13.7,260.5,27.5,268.5Zm20.1-29.7a40.4,40.4,0,0,1,2.7,14.1,17.7,17.7,0,0,1-.1,2.3h.1a18.5,18.5,0,0,1-3.5,9.9h-.1a11,11,0,0,1-8.3,4.1L45,251.6l-1.3.8h0l1.3-.7.6-1.6A31.1,31.1,0,0,0,47.6,238.8Zm-20-25.4c6,3.4,11.4,9.2,15.4,15.9h-.1a2.9,2.9,0,0,0-3.1-.2h-.1a3.4,3.4,0,0,0-.7,1.7v.6h0a4,4,0,0,0,0,1.1c.5,4.4,3.9,8.5,3.9,14.7a18.5,18.5,0,0,1-1.1,6.2l-3,8.8L32,235.1l-5.1,3-.8,2.2h0l-4.3,12.4-8.2-32.9c-.1-.4,0-.5.3-.4l2.6,1.5a.2.2,0,0,0,.3-.1v-1.6a.5.5,0,0,0-.3-.4l-8.1-4.5C12.5,209.4,19.6,208.7,27.6,213.4ZM4.7,226.6a21.6,21.6,0,0,1,2.1-9.8l10.9,41.1C10,249.2,4.7,237.1,4.7,226.6Z"
        transform="translate(-1 -0.7)"
      />
      <path
        d="M22.8,224.6l1.7-1-2.3-1.4-.8.5h0l.8-.5-1.8-1.1c-.1,0-.2,0-.2.2v1.6c0,.1.1.3.2.3l1.3.8h0Z"
        transform="translate(-1 -0.7)"
      />
      <path
        d="M26.9,238.1l5.1-3-1.3-5.3c-.1-.5,0-.6.5-.4l2.3,1.4c.1,0,.2,0,.2-.2v-1.5a.5.5,0,0,0-.2-.4L26.9,225l-1.2-.7-2.1,1.3Z"
        transform="translate(-1 -0.7)"
      />
      <path
        d="M23.6,225.6l2.1-1.3-1.2-.7-1.7,1C23.3,224.8,23.4,225.2,23.6,225.6Z"
        transform="translate(-1 -0.7)"
      />
      <path
        d="M38.9,202.6h0c-7.4-4.3-14.1-4.6-18.9-1.8L8.7,207.3a14.4,14.4,0,0,1,7.5-1.8h0l1.5.2h0l3.2.7h0a27.2,27.2,0,0,1,6.7,2.9,48.1,48.1,0,0,1,4.1,2.7,36.8,36.8,0,0,1,6.2,5.7l1.2,1.2c8.9,10.1,15,24.2,15,36.3,0,7.3-2.3,12.7-6,15.9H48a1,1,0,0,1-.5.4l-.3.3h-.3l-.6.4,11.3-6.6c4.8-2.8,7.8-8.7,7.8-17.1C65.4,231.6,53.6,211.1,38.9,202.6Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-5"
        d="M6.8,216.8a21.6,21.6,0,0,0-2.1,9.8c0,10.5,5.3,22.6,13,31.3Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-5"
        d="M16.5,218.8a.5.5,0,0,1,.3.4v1.6a.2.2,0,0,1-.3.1l-2.6-1.5c-.3-.1-.4,0-.3.4l8.2,32.9,4.3-12.4.8-2.2-3.3-12.5a1.7,1.7,0,0,0-.9-1l-1-.6-1.3-.8c-.1,0-.2-.2-.2-.3v-1.6c0-.2.1-.2.2-.2l1.8,1.1h0l2.3,1.4h0l1.2.7h0l1.2.7,6.6,3.7a.5.5,0,0,1,.2.4v1.5c0,.2-.1.2-.2.2l-2.3-1.4c-.5-.2-.6-.1-.5.4l1.3,5.3h0l6.8,27.1,3-8.8a18.5,18.5,0,0,0,1.1-6.2c0-6.2-3.4-10.3-3.9-14.7a4,4,0,0,1,0-1.1h0v-.6a3.4,3.4,0,0,1,.7-1.7h.1a2.9,2.9,0,0,1,3.1.2H43c-4-6.7-9.4-12.5-15.4-15.9-8-4.7-15.1-4-19.2.9Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-5"
        d="M47.5,271.4a1,1,0,0,0,.5-.4h.1c3.7-3.2,6-8.6,6-15.9,0-12.1-6.1-26.2-15-36.3l-1.2-1.2a36.8,36.8,0,0,0-6.2-5.7,48.1,48.1,0,0,0-4.1-2.7,27.2,27.2,0,0,0-6.7-2.9l-3.2-.6-1.5-.2c-9-.2-15.2,6.7-15.2,18.9-.1,16.8,11.8,37.4,26.5,45.9,7.6,4.5,14.5,4.7,19.4,1.5h.3ZM2.6,225.3h0c0-11.2,5.6-17.7,13.8-17.7h2.1a24.6,24.6,0,0,1,9.1,3.3c13.8,8,24.9,27.3,24.9,43.2a23.8,23.8,0,0,1-1.7,9.3,15.1,15.1,0,0,1-.9,1.8c-4,7.2-12.5,8.9-22.4,3.2h0C13.7,260.6,2.5,241.2,2.6,225.3Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-5"
        d="M35.1,269l-7.2-27.1-7.1,19.2a44.9,44.9,0,0,0,6.7,5l2.1,1.1h0A22,22,0,0,0,35.1,269Z"
        transform="translate(-1 -0.7)"
      />
      <path
        class="cls-5"
        d="M45,251.6l-6.6,17.5a11,11,0,0,0,8.3-4.1,21.4,21.4,0,0,0,3.6-12.1,40.4,40.4,0,0,0-2.7-14.1,31.1,31.1,0,0,1-2,11.2l-.6,1.6Z"
        transform="translate(-1 -0.7)"
      />
    </g>
    <g id="Blocke_1" data-name="Blocke 1">
      <g id="Shadow-2" data-name="Shadow">
        <polygon class="cls-1" points="113 269.2 70.4 293.7 71.1 294.2 113.9 269.5 113 269.2" />
        <polygon class="cls-1" points="73 295.3 116.3 270.3 115.4 270 72.2 294.9 73 295.3" />
        <polygon class="cls-1" points="75 296.5 118.9 271.2 118 270.9 74.3 296 75 296.5" />
        <polygon class="cls-1" points="76.8 297.5 121.3 271.9 120.3 271.6 76.1 297 76.8 297.5" />
        <polygon class="cls-1" points="78.8 298.6 123.8 272.8 122.9 272.5 78.1 298.2 78.8 298.6" />
        <path class="cls-1" d="M81.5,300.5l45.7-26.3h-.9L81.1,300Z" transform="translate(-1 -0.7)" />
        <path
          class="cls-1"
          d="M128.8,274.9l-55.7,32a.8.8,0,0,0,0,.9l56.7-32.6Z"
          transform="translate(-1 -0.7)"
        />
        <polygon class="cls-1" points="130.2 275.1 73 307.9 73.7 308.4 131.2 275.4 130.2 275.1" />
        <polygon class="cls-1" points="132.8 275.8 75 309.1 75.7 309.5 133.7 276.2 132.8 275.8" />
        <polygon class="cls-1" points="135.2 276.6 77 310.2 77.7 310.7 136.1 276.9 135.2 276.6" />
        <polygon class="cls-1" points="137.7 277.5 78.8 311.4 79.6 311.8 138.7 277.8 137.7 277.5" />
        <polygon class="cls-1" points="140.1 278.4 80.9 312.5 81.6 312.8 141 278.7 140.1 278.4" />
        <polygon class="cls-1" points="142.7 279.2 82.7 313.7 83.4 314 143.6 279.5 142.7 279.2" />
        <polygon class="cls-1" points="145.1 279.9 84.7 314.7 85.4 315.1 146 280.4 145.1 279.9" />
        <polygon class="cls-1" points="147.6 280.8 86.7 315.8 87.3 316.3 148.4 281.1 147.6 280.8" />
        <path
          class="cls-1"
          d="M106.5,267.5,65.8,290.8c.1.3.1.5.4.6l41.2-23.7Z"
          transform="translate(-1 -0.7)"
        />
        <polygon class="cls-1" points="108.1 267.5 66.5 291.4 67.2 291.9 109 267.7 108.1 267.5" />
        <polygon class="cls-1" points="110.6 268.3 68.4 292.6 69.1 293 111.4 268.6 110.6 268.3" />
        <polygon
          class="cls-1"
          points="159.4 285.5 107.7 315.3 108.4 315.5 160.1 285.8 159.4 285.5"
        />
        <polygon
          class="cls-1"
          points="161.5 286.5 109.7 316.3 110.3 316.7 162.2 286.8 161.5 286.5"
        />
        <polygon
          class="cls-1"
          points="163.7 287.6 111.6 317.4 112.3 317.8 164.4 287.8 163.7 287.6"
        />
        <polygon class="cls-1" points="165.8 288.6 113.6 318.6 114.3 319 166.5 288.8 165.8 288.6" />
        <polygon class="cls-1" points="168 289.6 115.6 319.7 116.2 320.1 168.7 290 168 289.6" />
        <path
          class="cls-1"
          d="M171.1,291.3l-52.5,30.1a1.7,1.7,0,0,0,1.4,0l51.8-29.7Z"
          transform="translate(-1 -0.7)"
        />
        <polygon
          class="cls-1"
          points="172.3 291.6 149.2 304.8 149.3 304.8 149.9 305.1 173 291.9 172.3 291.6"
        />
        <polygon class="cls-1" points="174.4 292.6 151.2 305.9 151.9 306.4 175.1 293 174.4 292.6" />
        <path
          class="cls-1"
          d="M177.3,294.6l-23.1,13.3.7.5,22.5-13.1C177.4,295,177.4,294.7,177.3,294.6Z"
          transform="translate(-1 -0.7)"
        />
        <polygon class="cls-1" points="155.8 308.7 173 298.7 174.4 297.2 155.1 308.2 155.8 308.7" />
        <polygon
          class="cls-1"
          points="157.8 309.8 168.8 303.3 170.3 301.8 157.1 309.4 157.8 309.8"
        />
        <polygon class="cls-1" points="159.8 310.8 165 307.9 166.4 306.2 159.1 310.5 159.8 310.8" />
        <path
          class="cls-1"
          d="M163.1,311.8l.2-.3-1.1.6A.9.9,0,0,0,163.1,311.8Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-1"
          d="M151.2,282.4,89.7,317.7H90c.2.2.3.2.4.2L152,282.5Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-1"
          d="M153.6,283.2l-51.8,29.9a1.7,1.7,0,0,1,1.4,0l51.3-29.4Z"
          transform="translate(-1 -0.7)"
        />
        <polygon class="cls-1" points="155.1 283.4 103.8 313 104.4 313.4 155.8 283.8 155.1 283.4" />
        <polygon
          class="cls-1"
          points="157.2 284.4 105.7 314.1 106.4 314.5 157.9 284.8 157.2 284.4"
        />
      </g>
      <g class="sbox" id="Box_4" data-name="Box 4">
        <path
          class="cls-2"
          d="M115.6,306.3h-.8l-1.3-.2L70.8,281.5v4.2l43.4,25.1h1.5Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-2"
          d="M67.2,283.7l2.3,1.3.2-4.2L67,279.3v4.2A.2.2,0,0,0,67.2,283.7Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-1"
          d="M161.5,278.9a1.5,1.5,0,0,0-.7-1.1l-47-27a3.1,3.1,0,0,0-2.8.1L66.8,276.6a1.6,1.6,0,0,0-.9,1.3v5.9a1.7,1.7,0,0,0,.7,1.2l46.9,26.9a3,3,0,0,0,2.6,0h.2l44.6-25.5c.6-.4.9-.7.9-1.3v-5.5A2.1,2.1,0,0,0,161.5,278.9Zm-47.4,31.9L70.7,285.7v-4.2l42.7,24.6,1.3.2h.8v4.5Zm-.8-59,46.9,27h.1l-.3.3-44.2,25.7a2,2,0,0,1-1.7.1L67,277.9c.2,0,.2,0,.3-.3L111.5,252A2.9,2.9,0,0,1,113.3,251.8ZM67.1,277.9Zm-.1,1.4,2.7,1.5-.2,4.2-2.3-1.3a.2.2,0,0,1-.2-.2Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-3"
          d="M67.3,277.6c-.1.3-.1.3-.3.3l47.1,27a2,2,0,0,0,1.7-.1L160,279.1l.3-.3h-.1l-46.9-27a2.9,2.9,0,0,0-1.8.2Z"
          transform="translate(-1 -0.7)"
        />
        <path class="cls-3" d="M67.1,277.9Z" transform="translate(-1 -0.7)" />
      </g>
      <g class="sbox" id="Box_1-2" data-name="Box 1">
        <path
          class="cls-2"
          d="M90.7,305.6h-.5a2.3,2.3,0,0,1-1.3-.3l-13.7-7.9v4.2l14.2,8.5a2.3,2.3,0,0,0,1.4-.1Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-2"
          d="M71.6,299.6,74,301v-4.2l-2.6-1.5v4.2A.1.1,0,0,0,71.6,299.6Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-3"
          d="M71.8,293.7c-.2.2-.2.2-.2.3l17.8,10.3a2.3,2.3,0,0,0,1.8-.1l5.7-3.5c.1-.1.3-.1.3-.2H97L79.2,290.1a2.8,2.8,0,0,0-1.7.2Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-1"
          d="M98.3,300.5a1.5,1.5,0,0,0-.7-1.2L79.8,289a2.6,2.6,0,0,0-2.8.1l-5.8,3.5a1.5,1.5,0,0,0-.9,1.3h.1a.5.5,0,0,0-.2.4v5.4a1.5,1.5,0,0,0,.7,1.2l17.8,10.3a2.8,2.8,0,0,0,1.3.3,1.7,1.7,0,0,0,1.2-.4h.2l6.1-3.3c.5-.4.8-.7.8-1.3v-6.1Zm-9,9.6-14.2-8.5v-4.2l13.7,7.9a2.3,2.3,0,0,0,1.3.3h.5V310A2.3,2.3,0,0,1,89.3,310.1Zm-10.1-20L97,300.5h.2c0,.1-.2.1-.3.2l-5.7,3.5a2.3,2.3,0,0,1-1.8.1L71.6,294c0-.1,0-.1.2-.3l5.7-3.4A2.8,2.8,0,0,1,79.2,290.1Zm13.1,14.3h1v4.9h-1Zm-20.8-9.1,2.6,1.5V301l-2.4-1.4a.1.1,0,0,1-.1-.1Z"
          transform="translate(-1 -0.7)"
        />
        <rect
          class="cls-2"
          x="90.3"
          y="306.3"
          width="4.9"
          height="1"
          transform="translate(-216.5 394.3) rotate(-89.1)"
        />
      </g>
      <g class="sbox" id="Box_5" data-name="Box 5">
        <path
          class="cls-2"
          d="M103.8,275.9v-4.5h-.6l-1.3-.3L78.6,257.6l-.2,4.3,24.1,14A1.9,1.9,0,0,0,103.8,275.9Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-2"
          d="M74.9,259.8l2.4,1.4v-4.3l-2.6-1.5v4.3A.1.1,0,0,0,74.9,259.8Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-3"
          d="M75.1,253.7l-.3.3,27.7,16a2.1,2.1,0,0,0,1.7-.1l27.3-15.7.3-.2h-.2l-27.5-16.1a2.1,2.1,0,0,0-1.7.1Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-1"
          d="M132.9,254.1a1.4,1.4,0,0,0-.7-1.1l-27.5-16.1a3.3,3.3,0,0,0-2.9.1L74.5,252.7a1.3,1.3,0,0,0-.8,1c-.1.2-.2.3-.2.5v5.5a1.4,1.4,0,0,0,.7,1.1l27.6,16.1a3,3,0,0,0,2.6,0h.1l27.3-15.5c.5-.4.8-.7.8-1.3v-5.2A1.6,1.6,0,0,0,132.9,254.1Zm-28.8-16.2L131.6,254h.2l-.3.2-27.3,15.7a2.1,2.1,0,0,1-1.7.1L74.8,254l.3-.3L102.4,238A2.1,2.1,0,0,1,104.1,237.9Zm22.7,25V258h1v4.9Zm-52-7.5,2.6,1.5v4.3l-2.4-1.4a.1.1,0,0,1-.1-.1Zm3.8,2.2,23.3,13.6,1.3.3h.6v4.5a1.9,1.9,0,0,1-1.3,0l-24.1-14Z"
          transform="translate(-1 -0.7)"
        />
        <rect
          class="cls-2"
          x="124.9"
          y="260"
          width="4.9"
          height="1"
          transform="translate(-136.1 382.9) rotate(-89.1)"
        />
      </g>
      <g id="Gears">
        <path
          class="cls-2"
          d="M114.1,295.3l-5-.7.7-1.5-1.7-.7a5.3,5.3,0,0,1-1.4-1.1l-2.5.4-1.4-3.2,2.4-.4a4.3,4.3,0,0,1,1-2.3l-1.8-1,3.8-2.3,1.8,1a17,17,0,0,1,4.6-.7l.5-1.3,5.1.7-.8,1.5,1.8.7,1.4,1.1,2.4-.4,1.5,3.2-2.5.4a3.4,3.4,0,0,1-1,2.3l1.9,1-3.9,2.3-1.7-1a17,17,0,0,1-4.6.7Zm-3.6-1.4,3,.4.6-1.3h.3a17.2,17.2,0,0,0,4.7-.7l.2-.2,1.6.9,2-1.2-1.5-.8.5-.4a3.4,3.4,0,0,0,1.1-2.5v-.4l2-.3-.7-1.4-2.1.2H122a3.8,3.8,0,0,0-1.4-1.1l-2-.9H118l.6-1.3-3-.5-.6,1.3h-.3a17.2,17.2,0,0,0-4.7.7l-.2.2-1.6-.9-2,1.2,1.5.8-.5.5a3,3,0,0,0-1.1,2.4v.4l-2,.3.7,1.5,2.1-.3h.2a8.1,8.1,0,0,0,1.4,1.2l2,.8.6.2Zm4.2-2.9a5.6,5.6,0,0,1-3.6-1.2,1.7,1.7,0,0,1,0-2.8,5.7,5.7,0,0,1,7,0,1.6,1.6,0,0,1,0,2.8A4.9,4.9,0,0,1,114.7,291Zm0-4.3a4.8,4.8,0,0,0-2.9.8,1,1,0,0,0-.4.8.9.9,0,0,0,.4.7,5.5,5.5,0,0,0,5.8,0c.3-.3.4-.5.4-.7a.9.9,0,0,0-.4-.8A5.7,5.7,0,0,0,114.7,286.7Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-1"
          d="M121.2,283.2a9.3,9.3,0,0,0-2.2-.8l.6-1.3-4-.6-.6,1.3a18.7,18.7,0,0,0-4.9.7l-1.7-1-2.9,1.7,1.7,1a4.1,4.1,0,0,0-1.3,2.9l-2.3.3,1.2,2.3,2.3-.3a4.2,4.2,0,0,0,1.6,1.2,8.4,8.4,0,0,0,2.1.8l-.6,1.3,4.1.6.5-1.3a18.1,18.1,0,0,0,4.9-.7l1.7,1,2.9-1.7-1.7-1a4.1,4.1,0,0,0,1.3-2.9l2.3-.3-1.2-2.3-2.3.3A7.9,7.9,0,0,1,121.2,283.2ZM118,288c-1.4,1.4-4.9,1.4-6.5,0a1.4,1.4,0,0,1,0-2.2c1.5-1.4,4.9-1.4,6.5,0A1.6,1.6,0,0,1,118,288Z"
          transform="translate(-1 -0.7)"
        />
      </g>
      <g class="sbox" id="Box_3-2" data-name="Box 3">
        <path
          class="cls-2"
          d="M156.2,297.3v-4.5h-.7a4.2,4.2,0,0,1-1.3-.3l-13.6-7.9v4l14.2,8.6Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-2"
          d="M137.1,286.7l2.3,1.4V284l-2.6-1.4v3.9A.2.2,0,0,0,137.1,286.7Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-3"
          d="M137.1,280.9c0,.2-.2.2-.2.3l17.8,10.4a3,3,0,0,0,1.8-.2l17.5-10c.1-.2.3-.2.3-.3h-.2l-17.8-10.3a2.1,2.1,0,0,0-1.7.1Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-1"
          d="M175.4,281.1a1.7,1.7,0,0,0-.7-1.2l-17.8-10.3a3.3,3.3,0,0,0-2.9.1l-17.5,10.1a1.5,1.5,0,0,0-.8,1.3V287a1.3,1.3,0,0,0,.7,1.1l17.8,10.3a2.5,2.5,0,0,0,1.3.3,1.8,1.8,0,0,0,1.3-.4h.1l17.6-9.9c.6-.4.9-.7.9-1.3v-6Zm-19.1-10.3,17.8,10.3h.2c0,.1-.2.1-.3.3l-17.5,10a3,3,0,0,1-1.8.2l-17.8-10.4c0-.1.2-.1.2-.3l17.5-10A2.1,2.1,0,0,1,156.3,270.8Zm13.1,19.1V285h1v4.8Zm-32.5-7.3,2.6,1.4v4.1l-2.3-1.4a.2.2,0,0,1-.2-.2Zm3.7,2.1,13.6,7.9a4.2,4.2,0,0,0,1.3.3h.7v4.5h-1.5l-14.2-8.6Z"
          transform="translate(-1 -0.7)"
        />
        <rect
          class="cls-2"
          x="167.5"
          y="287"
          width="4.9"
          height="1"
          transform="translate(-121.2 452.2) rotate(-89.1)"
        />
      </g>
      <g class="sbox" id="Box_2-2" data-name="Box 2">
        <polygon
          class="cls-3"
          points="159.1 262.4 155.2 264.7 157.9 266.3 161.6 263.9 159.2 262.4 159.1 262.4"
        />
        <path
          class="cls-3"
          d="M163.7,265.3l-3.8,2.4.6.3a3,3,0,0,1,1.1,1.7l3.9-2.3a4.6,4.6,0,0,0-.7-1.4Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-1"
          d="M165.2,265.2l-4.6-2.9a1.2,1.2,0,0,0-1.4,0l-4.7,2.7a.9.9,0,0,0-.5.9,1.5,1.5,0,0,0-.1.7v11a3.3,3.3,0,0,0,1.3,2.6l4.6,2.9h1.3a.3.3,0,0,0,.1-.2h.1l4.8-2.8a1.5,1.5,0,0,0,.6-1.3V267.7A3.3,3.3,0,0,0,165.2,265.2Zm-3.4,11.5-.5-.9,4.2-2.5.5.9Zm-.2-7a3,3,0,0,0-1.1-1.7l-.6-.3,3.8-2.4,1.1.7a4.6,4.6,0,0,1,.7,1.4Zm-2.8-2.7-2.6-1.6,3.8-2.3h.2l2.4,1.6Zm-3.8-.6v-.2h.2l4.6,2.8a3.4,3.4,0,0,1,.7,1.6v11.1c0,.2,0,.2-.2.2l-4.6-2.8a3.4,3.4,0,0,1-.7-1.6Z"
          transform="translate(-1 -0.7)"
        />
        <path
          class="cls-2"
          d="M160.3,281.9c.2,0,.2,0,.2-.2V270.6a3.4,3.4,0,0,0-.7-1.6l-4.6-2.8H155v11.3a3.4,3.4,0,0,0,.7,1.6Z"
          transform="translate(-1 -0.7)"
        />
        <rect
          class="cls-2"
          x="161.2"
          y="274.5"
          width="4.9"
          height="1"
          transform="translate(-119.3 122.9) rotate(-31)"
        />
      </g>
    </g>
    <g id="Smashing">
      <path
        d="M139.9,12.2v-.3a4.5,4.5,0,0,0,.2-.8,5.4,5.4,0,0,1,.5-2.2,1.4,1.4,0,0,1,.2-.7,8.3,8.3,0,0,1,2.9-3.7h0L131.8.9h0a2.5,2.5,0,0,0-2.1.1L116.4,8.7h.3c-1.1.6-1.7,2.1-1.3,4.2L125.1,66a9.6,9.6,0,0,0,4.3,6.4l1,.5,4.7,1.4.3.2,9.5-5.6.3.2c2.4,1.4,4.3,1.6,5.6.8l12.4-7.3a29.2,29.2,0,0,1,2.4,11.8,13.2,13.2,0,0,1-2.8,8.4l8.7,2.6a2.4,2.4,0,0,0,2.2-.2h-.1l13.3-7.8a3,3,0,0,0,1.3-2.7,6.6,6.6,0,0,0-.1-1.4h0l-9.7-53.2-10.3,6h0l10.2-6a9.4,9.4,0,0,0-4.2-6.4L161.8,21h0l12.3-7.2-1.1-.4-8.5-2.6-13.2,7.7,2.8.9H154l-3-.9,2,1.6L142.9,26c0-.1-.1-.2-.1-.3s-.1-.2-.1-.2h-.1a3.6,3.6,0,0,0-.3-.7l-13.1,7.7h0l13.1-7.7a.3.3,0,0,0-.1-.2h.1L142,24l-13.2,7.7h0L142,24v-.2l-13.2,7.7h0l13.2-7.7a1.5,1.5,0,0,1-.3-.7c0-.1,0-.2-.1-.2h0a4.5,4.5,0,0,0-.2-.8l-.3-.7h0v-.2l-13.2,7.7h0L141,21.2l-.3-.7h0l-.2-.7h.1c0-.1-.1-.1-.1-.2a3.1,3.1,0,0,0-.2-.8l-13.2,7.8h0l13.2-7.7a3.7,3.7,0,0,0-.2-.9,2,2,0,0,0-.1-.7,2.2,2.2,0,0,1-.1-.9,1.5,1.5,0,0,1-.1-.7v-.9"
        transform="translate(-1 -0.7)"
      />
      <g>
        <path
          class="cls-3"
          d="M130.5,72.4l-.9-.4a9.4,9.4,0,0,1-4-6.1l-9.7-53.2c-.3-1.7.1-3.1,1-3.6l.8-.2h.8l10.9,3.4a8.9,8.9,0,0,0-2.3,3.4l-.3.7a10.3,10.3,0,0,0-.5,2.4.4.4,0,0,1-.1.3v.7c0,.1,0,.2-.1.2v3.3a1.9,1.9,0,0,0,.1.8v.4a.9.9,0,0,1,.1.5.4.4,0,0,0,.1.3v.4a6.4,6.4,0,0,0,.2.7h0l.2.6v.2h0a.3.3,0,0,0,.1.2,2.5,2.5,0,0,0,.2.7,2.5,2.5,0,0,1,.2.7.3.3,0,0,0,.1.2h0v.6l.3.8h0V31l.3.6h.1l.2.3v.2c0,.1,0,.1.1.2a.3.3,0,0,0,.1.2.4.4,0,0,0,.1.3c0,.1.1.2.2.4h0c0,.1,0,.2.1.2s.1.2.1.3h.1v.2c0,.1,0,.1.1.2l.3.7h.1a.1.1,0,0,0,.1.1.4.4,0,0,0,.1.3h.1a.4.4,0,0,1,.1.3c.1,0,.1,0,.1.1l.2.3c.1.1.1.2.2.4a.1.1,0,0,1,.1.1.1.1,0,0,0,.1.1c0,.1,0,.1.1.2s.1.1.1.2a.4.4,0,0,1,.1.3c.1,0,.1,0,.1.1s.2.2.2.3.1.3.2.4.1.2.3.3.1.1.1.2h.1l.3.4.4.6.2.2h0l.2.3h.1c0,.1.1.2.2.3h0a81.1,81.1,0,0,0,7.6,8.9c10,10.1,10.3,15.7,10.2,17.2a2.9,2.9,0,0,1-1.1,2.1,3.3,3.3,0,0,1-1.5.4h0a7.3,7.3,0,0,1-3.6-1.2l-.3-.2a41.3,41.3,0,0,1-9.6-8.5,35.1,35.1,0,0,1-3.4-4.7l-.5-.2h0l-.4.2-4.8,9.6a.5.5,0,0,0,.1.6c2.1,2.5,4.6,5.2,7.2,7.8Z"
          transform="translate(-1 -0.7)"
        />
        <path
          d="M117.7,9.4h.7l10,3.2a11.2,11.2,0,0,0-1.8,2.8l-.3.8a12.3,12.3,0,0,0-.5,2.5.8.8,0,0,1-.1.4h0v.6h0a.9.9,0,0,0-.1.5v2.9a2.8,2.8,0,0,0,.1.9v.3a1.3,1.3,0,0,1,.1.6.3.3,0,0,0,.1.2v.5a4.1,4.1,0,0,1,.2.7v.2c.1.2.1.4.2.5v.2c0,.1.1.2.1.3s.1.2.1.3v.5c.1.2.2.3.2.5s.1.2.1.3l.2.5v.2h.1l.2.6v.2h0c0,.1.1.1.1.2a1.5,1.5,0,0,0,.3.7h0a.1.1,0,0,0,.1.1h0c0,.1.1.2.1.3s.1.1.1.2.1.1.1.2.1.1.1.2a.4.4,0,0,1,.1.3c.1.1.1.2.2.4h0a.3.3,0,0,1,.1.2l.2.3h0a.3.3,0,0,1,.1.2l.2.3.3.6a.1.1,0,0,0,.1.1h0l.2.3c0,.1,0,.1.1.2h0a.3.3,0,0,0,.1.2.1.1,0,0,0,.1.1h0l.2.3c0,.1.1.2.2.3s0,.1.1.2h0l.2.3h0c0,.1.1.1.1.2a.3.3,0,0,0,.1.2c0,.1,0,.1.1.1h0l.2.3c0,.1.1.2.2.3a.9.9,0,0,0,.3.5.1.1,0,0,1,.1.1h.1c0,.1.1.3.4.5s.2.3.3.5.1.1.2.2h0l.2.4h0l.3.4h0a.1.1,0,0,0,.1.1,63.9,63.9,0,0,0,7.6,8.9c7.8,8,10.3,13.9,10,16.8a2.2,2.2,0,0,1-.9,1.7,1.6,1.6,0,0,1-1.2.4,7.1,7.1,0,0,1-3.3-1.1h-.2a.1.1,0,0,0-.1-.1,38.3,38.3,0,0,1-9.5-8.4,47.6,47.6,0,0,1-3.4-4.6,1.1,1.1,0,0,0-.9-.5h0a1.1,1.1,0,0,0-.9.5L126,64.7c-.1.1-.1.1-.1.2l-9.5-52.3c-.3-1.5,0-2.7.7-3.1h.6m8.4,56.4h0c2,2.4,4.1,4.6,5.9,6.5l-1.3-.4a1.5,1.5,0,0,1-.8-.4,8.6,8.6,0,0,1-3.8-5.7h0M117.7,8.4l-1,.2c-1.1.6-1.7,2.1-1.3,4.2L125.1,66a9.6,9.6,0,0,0,4.3,6.4l1,.5,4.7,1.4h.4a124.7,124.7,0,0,1-8.6-9.2h0l4.7-9.6c.2.2,1.4,2.2,3.6,4.8h0a39.4,39.4,0,0,0,9.7,8.5l.3.2a7.2,7.2,0,0,0,3.8,1.3,3.5,3.5,0,0,0,1.8-.5c2.8-2,1.5-9.4-9-20.1a76.6,76.6,0,0,1-7.5-8.7l-.3-.4c0-.2-.2-.3-.2-.4l-.3-.4-.4-.6c-.1-.1-.2-.2-.2-.3h-.1c0-.2-.2-.3-.2-.4l-.3-.3-.3-.6h0c-.1-.1-.2-.1-.2-.3l-.3-.4c0-.1-.1-.2-.2-.3a2.5,2.5,0,0,0-.4-.7c0-.1-.1-.1-.1-.3h0l-.3-.4c0-.1-.1-.1-.1-.3l-.4-.6h0c-.1,0-.1-.1-.1-.2l-.3-.5a.4.4,0,0,0-.1-.3l-.3-.7h0c-.1,0-.1-.2-.1-.2l-.3-.6h0c0-.1-.1-.1-.1-.2h0l-.3-.7v-.2a3.4,3.4,0,0,1-.3-.8c0-.2-.2-.4-.2-.7h0a.3.3,0,0,1-.1-.2h0a6.4,6.4,0,0,1-.2-.7,2.5,2.5,0,0,1-.2-.7h0c0-.1-.1-.1-.1-.2a6.4,6.4,0,0,1-.2-.7h0a4.5,4.5,0,0,1-.2-.8,1.7,1.7,0,0,0-.1-.7,2.5,2.5,0,0,1-.1-.9,1.7,1.7,0,0,1-.1-.7v-.9h0v-2c0-.2.1-.4.1-.6h0v-.2a2.5,2.5,0,0,1,.1-.8h0a8.6,8.6,0,0,1,.5-2.3h0a3.6,3.6,0,0,1,.3-.7,8.5,8.5,0,0,1,2.8-3.7h0L118.7,8.6h-1Z"
          transform="translate(-1 -0.7)"
        />
      </g>
      <g>
        <path
          class="cls-3"
          d="M172.5,85.1l-.9-.2-8-2.4a13.7,13.7,0,0,0,2.5-8.1,29.9,29.9,0,0,0-2.4-12,43,43,0,0,0-3.5-6.7c-.1-.1-.2-.2-.2-.3l-.3-.4c-.1-.2-.1-.4-.3-.5l-.3-.5a.1.1,0,0,1-.1-.1h-.1l-.3-.5-.3-.4-.3-.4c0-.1-.3-.4-.5-.6s-.2-.2-.2-.3l-.3-.3-.4-.5-.2-.3-.2-.3-.3-.3h-.1l-.2-.2c-.1-.2-.3-.3-.4-.4l-.3-.4-.2-.2-.7-.8-.3-.3a7.6,7.6,0,0,0-.9-.9l-.3-.3a2.3,2.3,0,0,0-.7-.7l-1.1-1.1-2-1.9-.2-.3a18.5,18.5,0,0,1-1.4-1.4l-.3-.3c0-.1-.1-.1-.1-.2s-.3-.4-.5-.5l-.3-.4c-.1-.1-.1-.2-.2-.2h-.1l-.8-1.1a28.3,28.3,0,0,1-2.8-4.3l-.7-1.5a5.8,5.8,0,0,1-.6-3.9c0-.2.1-.3.1-.4a2.3,2.3,0,0,1,2.1-1.1,5.1,5.1,0,0,1,2,.4l1.5.7.3.2h.2a47.5,47.5,0,0,1,6.7,5.3l.5.5.5.7.3.3a22.2,22.2,0,0,1,1.9,2.3l1,1.5c.2.3.3.5.6.5a.5.5,0,0,0,.5-.3l3.7-9.7c.1-.1.1-.3-.1-.5l-.7-.9-.2-.2c-.1-.2-.3-.3-.4-.4l-.3-.4-.5-.5-.4-.4c-.1-.1-.1-.1-.1-.2h-.1l-.5-.6-.5-.5-.5-.5h-.1l-.5-.6-.3-.2-.8-.8-.3-.2c0-.1-.1-.1-.1-.2l-.3-.2c-.1-.1-.2-.2-.2-.3l-.4-.2h-.1l-.2-.2h-.2c0-.1,0-.1-.1-.1l-.2-.3h-.2c0-.1-.1-.1-.2-.2l-.2-.2-.5-.4,6,1.8a2.3,2.3,0,0,1,1.1.4,8.9,8.9,0,0,1,4.1,6.1l9.7,53.2a4.3,4.3,0,0,1-.4,3.1l-.3.2h-.2a1.6,1.6,0,0,1-.9.3Z"
          transform="translate(-1 -0.7)"
        />
        <path
          d="M155.5,20.9l3.7,1.2h.1l1,.3a8.9,8.9,0,0,1,3.8,5.8l.2,1.1,1,5.4,8.5,46.7a3.8,3.8,0,0,1-.3,2.7l-.2.2h-.1a.1.1,0,0,1-.1.1l-.6.2h-.7l-7.4-2.3a14.5,14.5,0,0,0,2.2-7.7,29.4,29.4,0,0,0-2.5-12.3,43,43,0,0,0-3.5-6.7c-.1-.1-.1-.3-.2-.4a.5.5,0,0,1-.2-.4,2.3,2.3,0,0,0-.5-.5l-.2-.4c0-.1-.1-.1-.1-.2h-.1a.1.1,0,0,0-.1-.1.8.8,0,0,0-.2-.4l-.3-.4-.3-.4-.6-.7h.1l-.3-.2-.2-.4-.4-.5h0c-.1-.1-.1-.2-.2-.2l-.3-.4c0-.1-.1-.2-.2-.3h-.1a.7.7,0,0,0-.3-.3l-.3-.4-.3-.4h-.1l-.2-.2-.7-.8h-.2a9.4,9.4,0,0,0-1-1l-.3-.3-.6-.6h-.3l-.9-.9-1.9-1.9-.3-.2-1.3-1.4-.3-.4c-.1,0-.1,0-.1-.1H147l-.4-.5-.3-.4c-.1-.1-.2-.2-.2-.3a.1.1,0,0,1-.1-.1l-.8-1h0a24.1,24.1,0,0,1-2.8-4.3h0a9.1,9.1,0,0,1-.7-1.4,5.9,5.9,0,0,1-.5-3.5h0a.4.4,0,0,1,.1-.3c.1-.2.4-.8,1.6-.8a4.5,4.5,0,0,1,1.8.4,5.1,5.1,0,0,1,1.5.7h.3a.1.1,0,0,1,.1.1,36.1,36.1,0,0,1,6.6,5.2l.5.5.5.6a.1.1,0,0,1,.1.1l.3.2,1.9,2.3a8.5,8.5,0,0,0,.9,1.4,1.2,1.2,0,0,0,1,.8,1,1,0,0,0,1-.6V39l2.8-7.2.2-.5.5-1.4v-.3a1,1,0,0,0-.2-1l-.8-.9h0l-.2-.3-.3-.3a.8.8,0,0,0-.4-.4l-.5-.6-.4-.4v-.2l-.5-.6h-.3l-.2-.2-.5-.5h-.2l-.2-.3-.3-.3-.3-.2-.6-.6H157l-.4-.2a.1.1,0,0,0-.1-.1l-.2-.3H156l-.4-.4h0a.1.1,0,0,1-.1-.1M151,18.5l2,1.6.6.5.2.2.3.3.3.2.3.3c.2.1.2.2.3.3l.6.4.2.3.4.3.2.2.7.7.2.2.5.5h.2c.3.2.4.5.7.7l.2.2.6.7a.3.3,0,0,0,.1.2l.9,1a4.6,4.6,0,0,1,.7.7l.2.3a3.6,3.6,0,0,1,.8.9v.2H162l-.5,1.3h0l-.2.5h0l-2.8,7.3v.2a8.6,8.6,0,0,0-1.2-1.8l-1.9-2.4-.3-.2a1.3,1.3,0,0,0-.6-.7l-.5-.5a45.9,45.9,0,0,0-6.7-5.4l-.5-.3-1.6-.8a6.4,6.4,0,0,0-2.2-.4,2.4,2.4,0,0,0-2.5,1.4h0c-.1.1-.1.3-.2.4h0a6.8,6.8,0,0,0,.6,4.2h0a9.1,9.1,0,0,0,.7,1.4h0a27.4,27.4,0,0,0,2.9,4.4l.8,1.1.3.3.7.9c.2.2.4.3.5.5l1.4,1.5.3.2a17,17,0,0,0,1.9,1.9,9.4,9.4,0,0,0,1,1l.2.2,1,1a3.4,3.4,0,0,1,.8.9l.3.2.7.8.2.2.7.8c.2.1.2.2.3.3l.6.7a.3.3,0,0,0,.1.2l.7.9c.1,0,.2.2.2.2l.5.7c.2.1.2.1.3.3a2.2,2.2,0,0,1,.5.8l.2.3a2.1,2.1,0,0,1,.4.6l.3.3.5.8a52,52,0,0,1,3.4,6.6,29.2,29.2,0,0,1,2.4,11.8,13.2,13.2,0,0,1-2.8,8.4l8.7,2.6,1,.2a1.9,1.9,0,0,0,1.2-.4h.3l.3-.3a4.8,4.8,0,0,0,.4-3.5l-8.5-46.6-.9-5.5h0l-.2-1.1a9.7,9.7,0,0,0-4.3-6.4,3.2,3.2,0,0,0-1.3-.5L154,19.4l-3-.9Z"
          transform="translate(-1 -0.7)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState(["toggleConfig", "startConfig", "isAnimationDisabled", "viewportSize"]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    smashingAnim() {
      const path = this.$refs["connecting-smashing"],
        pathlength = path.getTotalLength();

      gsap.set(path, {
        strokeDashoffset: pathlength,
        strokeDasharray: pathlength,
      });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: "#milestone-smashing",
            toggleActions: this.toggleConfig,
            start: this.startConfig,
          },
          defaults: {
            duration: 1,
            ease: "sine",
          },
        })
        .add("smashing")
        .from(
          ".sbox",
          {
            duration: 0.5,
            opacity: 0,
            scale: 0.5,
            transformOrigin: "50% 50%",
            stagger: 0.1,
            ease: "back",
          },
          "smashing"
        )
        .from(
          "#Wordpress_Logo",
          {
            opacity: 0,
            scale: 0.5,
            transformOrigin: "50% 50%",
          },
          "smashing+=0.5"
        )
        .from(
          "#LOGO",
          {
            opacity: 0,
            scale: 0.5,
            transformOrigin: "50% 50%",
          },
          "smashing+=1"
        )
        .from(
          "#Smashing",
          {
            opacity: 0,
            scale: 0.5,
            transformOrigin: "50% 50%",
          },
          "smashing+=1.5"
        )
        .to(
          path,
          {
            strokeDashoffset: 0,
          },
          "smashing"
        );
    },
  },
  mounted() {
    this.smashingAnim();
  },
};
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: #0e1e25;
}

.cls-2 {
  fill: #ffad43;
}

.cls-3 {
  fill: #fff;
}

.cls-4 {
  fill: none;
}

.cls-5 {
  fill: #f6f6f6;
}

.cls-10 {
  stroke: #000;
  stroke-miterlimit: 10;
  stroke-width: 2px;
  fill: none;
}
</style>
